import styled from 'styled-components';

import { EditorType } from '../../../containers/Editor/constants';

interface PagesWrapperProps {
	editorType: EditorType;
	zoom: number;
}

const PagesWrapper = styled('div')`
	flex: 1 1 auto;
	display: flex;

	${({ editorType }: PagesWrapperProps) => editorType === EditorType.INDESIGN && `
		justify-content: center;
		align-items: center;
		margin: auto;
	`}

	${({ editorType }: PagesWrapperProps) => editorType === EditorType.HTML && `
		position: relative;
		flex-direction: column;
	`}

	${({ editorType, zoom }: PagesWrapperProps) => editorType === EditorType.INDESIGN && zoom <= 1 && `
		overflow: hidden;
	`}

	${({ editorType, zoom }: PagesWrapperProps) => editorType === EditorType.HTML && zoom !== 1 && `
		transform: scale(${zoom});
		transform-origin: ${zoom < 1 ? 'center top' : '0 0'};
	`}
`;

export {
	PagesWrapper,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/Spread/styles.ts